





































































































































































import { Component, Vue, Provide, Mixins, Watch } from 'vue-property-decorator';
import MixinResults from '@/plugins/podolib/services/helper/mixins/results';

@Component({
  components: {
    ChartRawWalkingBanner: () => import('@/components/charts/walking/ChartRawWalkingBanner.vue'),
    ChartRawPhaseWalkSteps: () => import('@/components/charts/walking/ChartRawPhaseWalkSteps.vue'),
    ChartRawRatioPropulsion: () => import('@/components/charts/walking/ChartRawRatioPropulsion.vue'),
    ChartRawPhaseWalkAdvanced: () => import('@/components/charts/walking/ChartRawPhaseWalkAdvanced.vue'),
    ChartRawGaitLine: () => import('@/components/charts/walking/ChartRawGaitLine.vue'),
    ElementBlocInterpretation: () => import('@/components/elements/ElementBlocInterpretation.vue'),
    ElementBlocGeneralInterpretation: () => import('@/components/elements/ElementBlocGeneralInterpretation.vue'),
    PatientAcquisitionComments: () => import('@/components/patients/PatientAcquisitionComments.vue'),
    //
    ElementResultsTooltip: () => import('@/components/elements/ElementResultsTooltip.vue'),
    ElementInterpretationManualBanner: () => import('@/components/elements/ElementInterpretationManualBanner.vue'),
  },
})
export default class PatientResultsWalkingGenerals extends Mixins(MixinResults) {
  @Provide() advancedMode: boolean = false;
  @Provide() absoluteValues: boolean = false;

  getCols(basicValue: number) {
    return this.compareAcquisition ? 12 : basicValue;
  }
}
